/*=========================================================================================
  File Name: moduleAuthGetters.js
  Description: Auth Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import Vue from 'vue'


export default {
  isAuth (state) {
    return !!(state.auth || localStorage.getItem('accessToken') || Vue.$cookies.get('accessToken'))
  },
  isHasRole (state) {
    const role = state.user && state.user.user_roles && state.user.user_roles.filter(x => x.program_id === 2).length > 0
    if (role) {
      return true
    } else if (localStorage.getItem('user')) {
      const user = JSON.parse(localStorage.getItem('user'))
      return user && user.user_roles && user.user_roles.filter(x => x.program_id === 2).length > 0
    } else {
      return false
    }
  },
  isCategorized (state) {
    const category = state.user && state.user.category_groups && state.user.category_groups.filter(x => x.project.id === 2).length > 0
    if (category) {
      return true
    } else if (localStorage.getItem('user')) {
      const user = JSON.parse(localStorage.getItem('user'))
      return user && user.category_groups && user.category_groups.filter(x => x.project.id === 2).length > 0
    } else {
      return false
    }
  }
}
